// extracted by mini-css-extract-plugin
module.exports = {"tabGroup":"_1VzVgl2bXEbw-oIjPZW8SY","badge":"_1taNHqL5h9bpryuuyUI_fk"};